import { Provider } from '@angular/core';
import {
  CreateTaskGroupTypeUseCase,
  DeleteTaskGroupTypeUseCase,
  GetTaskGroupTypeAvailableBySectorIdUseCase,
  GetTaskTaskGroupTypesUseCase,
  UpdateTaskGroupTypeUseCase,
} from '@app/application/use-cases/task-group-type';
import { TaskGroupTypeRepository } from '@app/domain/repositories/task-group-type.repository';
import { TaskGroupTypeRepositoryImpl } from '../repositories/task-group-type.repository.impl';

// The dependency injection wiring
export const TASK_GROUP_TYPE_PROVIDERS: Provider[] = [
  // Repositories
  { provide: TaskGroupTypeRepository, useClass: TaskGroupTypeRepositoryImpl },
  // Use Cases
  {
    provide: CreateTaskGroupTypeUseCase,
    useFactory: (taskGroupTypeRepo: TaskGroupTypeRepository) =>
      new CreateTaskGroupTypeUseCase(taskGroupTypeRepo),
    deps: [TaskGroupTypeRepository],
  },
  {
    provide: UpdateTaskGroupTypeUseCase,
    useFactory: (taskGroupTypeRepo: TaskGroupTypeRepository) =>
      new UpdateTaskGroupTypeUseCase(taskGroupTypeRepo),
    deps: [TaskGroupTypeRepository],
  },
  {
    provide: GetTaskTaskGroupTypesUseCase,
    useFactory: (taskGroupTypeRepo: TaskGroupTypeRepository) =>
      new GetTaskTaskGroupTypesUseCase(taskGroupTypeRepo),
    deps: [TaskGroupTypeRepository],
  },
  {
    provide: GetTaskGroupTypeAvailableBySectorIdUseCase,
    useFactory: (taskGroupTypeRepo: TaskGroupTypeRepository) =>
      new GetTaskGroupTypeAvailableBySectorIdUseCase(taskGroupTypeRepo),
    deps: [TaskGroupTypeRepository],
  },
  {
    provide: DeleteTaskGroupTypeUseCase,
    useFactory: (taskGroupTypeRepo: TaskGroupTypeRepository) =>
      new DeleteTaskGroupTypeUseCase(taskGroupTypeRepo),
    deps: [TaskGroupTypeRepository],
  },
];
